export default {
    "created": "Optiunea a fost creata cu succes",
    "updated": "Optiunea a fost actualizata cu succes",
    "deleted": "Optiunea a fost ștersa cu succes",
    "restored": "Optiunea a fost restaurata cu succes",
}
